import React from "react";

import { Typography } from "@mui/material";

import { TabPanelObject } from "components/TabPanelObject.js";
import { TabPanelQuery } from "components/TabPanelQuery.js";
import { TabPanelCreate } from "components/TabPanelCreate.js";
import { TabPanelUpdate } from "components/TabPanelUpdate.js";
import { TabPanelDelete } from "components/TabPanelDelete.js";
import { TabPanelRead } from "components/TabPanelRead.js";
import { TabStrip } from "components/ApiTabs/ApiTabs";

import { ItemOtherTab } from "views/ApiDoc/ApiSections/Item/ItemOtherTab";

export function Section(props) {
  const section = props.match.params.section;
  const sections = require.context(
    "views/ApiDoc/ApiSections",
    true,
    /constants.js/
  );
  const {
    SECTION_NAME,
    ATTRIBUTES,
    EXAMPLE_JSON,
    QUERY_PARAMS,
    LINE_ITEM,
    SAMPLE_QUERY_REQUEST,
    INTRO_TEXT,
  } = sections(`./${section}/constants.js`);

  // Handle some naming exceptions
  const friendlyName = PascalToFriendly(SECTION_NAME);
  const endpointNameExceptions = {
    SerialNumber: "Serial",
  };
  const name =
    endpointNameExceptions[SECTION_NAME] === undefined
      ? SECTION_NAME
      : endpointNameExceptions[SECTION_NAME];

  const [value, setValue] = React.useState(0);

  const hasOtherTab = section === "Item";

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <React.Fragment>
      <h2 style={{ marginTop: "10px" }}>{friendlyName}</h2>
      <Typography
        variant="body2"
        dangerouslySetInnerHTML={{ __html: INTRO_TEXT }}
      />
      <TabStrip
        value={value}
        handleChange={handleChange}
        hasOtherTab={hasOtherTab}
      />
      <TabPanelObject
        friendlyName={PascalToFriendly(name)}
        parentAttributes={ATTRIBUTES}
        childAttributes={LINE_ITEM}
        value={value}
        exampleJson={EXAMPLE_JSON}
      />
      <TabPanelCreate
        name={name}
        friendlyName={PascalToFriendly(name)}
        value={value}
        attributes={ATTRIBUTES}
        lineItems={LINE_ITEM}
      />
      <TabPanelQuery
        name={name}
        friendlyName={PascalToFriendly(name)}
        value={value}
        queryParams={QUERY_PARAMS}
        sampleRequest={SAMPLE_QUERY_REQUEST}
      />
      <TabPanelRead
        name={name}
        friendlyName={PascalToFriendly(name)}
        value={value}
      />
      <TabPanelUpdate
        name={name}
        friendlyName={PascalToFriendly(name)}
        value={value}
        attributes={ATTRIBUTES}
        lineItems={LINE_ITEM}
      />
      <TabPanelDelete
        name={name}
        friendlyName={PascalToFriendly(name)}
        value={value}
      />
      {hasOtherTab && (
        <ItemOtherTab
          name={name}
          friendlyName={PascalToFriendly(name)}
          value={value}
          childAttributes={LINE_ITEM}
        />
      )}
    </React.Fragment>
  );

  function PascalToFriendly(pascal) {
    // Handle acronymns
    if (pascal.toUpperCase() === pascal) {
      return pascal;
    }
    return pascal.replace(/([A-Z])/g, " $1").substr(1);
  }
}
